import { render, staticRenderFns } from "./ReassignPatiensModal.vue?vue&type=template&id=a42d8966"
import script from "./ReassignPatiensModal.vue?vue&type=script&lang=js"
export * from "./ReassignPatiensModal.vue?vue&type=script&lang=js"
import style0 from "./ReassignPatiensModal.vue?vue&type=style&index=0&id=a42d8966&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports